import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionTitle } from "@/components/AppTable";
import { toast } from "sonner";
import { Trash, Plus } from "@phosphor-icons/react";

export default function Alerts() {
  const [alerts, setAlerts] = useState([]);
  const [form, setForm] = useState({ name: "", rule_type: "rating_below", threshold: 3.0 });

  const load = () => api.get("/alerts").then(r => setAlerts(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    await api.post("/alerts", { ...form, threshold: Number(form.threshold) });
    toast.success("Alert created");
    setForm({ name: "", rule_type: "rating_below", threshold: 3.0 });
    load();
  };

  const remove = async (id) => { await api.delete(`/alerts/${id}`); load(); };

  return (
    <div className="p-8 space-y-6">
      <SectionTitle eyebrow="Rules" title="Alerts" />

      <form onSubmit={create} className="border border-border p-4 bg-secondary/30 grid grid-cols-1 md:grid-cols-4 gap-2">
        <input required data-testid="alert-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
               placeholder="Alert name" className="border border-input bg-background px-3 py-2 text-sm rounded-sm" />
        <select data-testid="alert-type" value={form.rule_type} onChange={(e) => setForm({ ...form, rule_type: e.target.value })}
                className="border border-input bg-background px-3 py-2 text-sm rounded-sm">
          <option value="rating_below">Rating below</option>
          <option value="new_app_installs">New app with installs ≥</option>
        </select>
        <input type="number" step="0.1" value={form.threshold} onChange={(e) => setForm({ ...form, threshold: e.target.value })}
               data-testid="alert-threshold"
               className="border border-input bg-background px-3 py-2 text-sm rounded-sm" />
        <button data-testid="btn-create-alert" className="bg-primary text-primary-foreground text-sm px-3 py-2 rounded-sm flex items-center justify-center gap-1">
          <Plus size={14} /> Create
        </button>
      </form>

      <div className="border border-border">
        <table className="w-full text-sm">
          <thead className="bg-secondary/60 border-b border-border">
            <tr className="text-left overline-label text-muted-foreground">
              <th className="px-3 py-2">Name</th><th className="px-3 py-2">Rule</th>
              <th className="px-3 py-2 text-right">Threshold</th><th className="px-3 py-2 text-right">Matches</th><th></th>
            </tr>
          </thead>
          <tbody>
            {alerts.map((a) => (
              <tr key={a.id} className="border-b border-border/60">
                <td className="px-3 py-2.5 font-medium">{a.name}</td>
                <td className="px-3 py-2.5 text-xs">{a.rule_type}</td>
                <td className="px-3 py-2.5 text-right font-mono text-xs">{a.threshold}</td>
                <td className="px-3 py-2.5 text-right font-mono">{a.match_count}</td>
                <td className="px-3 py-2.5 text-right">
                  <button data-testid={`btn-del-alert-${a.id}`} onClick={() => remove(a.id)}
                          className="p-1.5 hover:bg-destructive/10 hover:text-destructive rounded-sm"><Trash size={14} /></button>
                </td>
              </tr>
            ))}
            {!alerts.length && <tr><td colSpan={5} className="px-3 py-8 text-center text-muted-foreground">No alerts yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
